import z from 'zod';

export const WorkOrderEntitySchema = z.object({
    id: z.string(),
    tuid: z.string(),
    notes: z.string(),
});

export type WorkOrderEntity = z.infer<typeof WorkOrderEntitySchema>;
